export const MESSAGE = {
  Loading: "しばらくお待ちください。...",
  SystemError: "システムエラーが発生しました。",
  InvalidUser: "アカウントIDは、必須です。",
  InvalidPassWord: "パスワードは、必須です。",
  InvalidAlphanumeric: "入力可能な文字は、英数字です。",
  UpdatedSoukouKm: "走行距離が更新されました。",
  UpdatedMemo: "メモが更新されました。",
  UpdatedOmonaYouto: "主な用途が更新されました。",
  UpdatedFrontTantousha: "フロントが更新されました。",
  UpdatedQuestionnaire: "アンケートが更新されました。",
  UpdatedConfirmationBeforeEntry: "入庫前確認の情報が更新されました。",
  SaveWorkShubetsu: "表示設定を更新しました",
  SaveNoChangeWorkShubetsu: "更新対象がありません",
  SoukouKmNotEntered: "走行距離が未入力です",
  ExceedStaffSeleced: "整備士と補助整備士の選択が上限(3人)を超えています",
  InvalidJuuryouzei: "重量税が未設定です。",
  InvalidJibaiseiki: "自賠責保険料が未設定です。",
  InvalidInshidai: "検査印紙代が未設定です。",
  InvalidRyoukinRank: "料金ランクが未設定です。",
  UpdatedInspections: "検査結果が更新されました。",
  NoData: "データがありません。",
  NoPartSelection: "作業指示は、ありません。",
  AlertFutureDate: "未来日付のものは車検を開始できません",
  AskChangeInspectResult: "判定結果を変更すると選択されている作業および部品が初期化されますが、よろしいでしょうか？",
  AskMD15: "部品選択が完了していない作業がありますが、次へ進みますか？",
  AskSaveMD468: "確定されていない項目がありますが、次に進みますか？",
  BelowLastSoukou: "前回走行距離を下回っています",
  SeibiNotSelectDotenken: "検査結果に対する作業について、お客様が確定されていません。",
  ReservationCancel: "入力された予約番号は、受付情報が削除されたか、キャンセルされました。",
  YoyakuNoisExpired: "予約番号の有効期限が切れています。再度、工場側画面で予約情報を開いてください。",
  UpdatedShakenCouse: "車検メニューが変更されました。車検検査費用をご確認ください。",
  /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [START] */
  UpdatedJizenEstimate: "事前見積情報が更新されました。",
  UpdatedShakenIntegrityError: "整合性エラーのため、更新に失敗しました。他で更新されている可能性があります。"
  /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [END] */
};